var _style, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDoorbellTransformer01({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 16 16",
    style: {
      enableBackground: "new 0 0 16 16"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#1E1E1C;}\n\t.st1{fill:#FFFFFF;}\n\t.st2{fill:#FFFFFF;}\n\t.st3{enable-background:new    ;}\n\t.st4{fill:none;stroke:#FFFFFF;stroke-width:0.5;stroke-miterlimit:10;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M13.83,13.83H2.16V2.17h11.67V13.83z M2.66,13.33h10.67V2.67H2.66V13.33z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("ellipse", {
    className: "st2",
    cx: 8.01,
    cy: 8.01,
    rx: 3.05,
    ry: 3.39
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M8.01,11.52c-1.75,0-3.17-1.58-3.17-3.51S6.26,4.5,8.01,4.5s3.17,1.58,3.17,3.51S9.76,11.52,8.01,11.52z  M8.01,4.75c-1.61,0-2.92,1.46-2.92,3.26s1.31,3.26,2.92,3.26c1.61,0,2.92-1.46,2.92-3.26S9.62,4.75,8.01,4.75z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDoorbellTransformer01);
export default __webpack_public_path__ + "static/media/DoorbellTransformer-01.eb089ac4f8df3295c2446c39d7676098.svg";
export { ForwardRef as ReactComponent };